module.exports = __webpack_public_path__ + "media/device_images/iPhoneGroup-9ddc0baa.svg";